export default __webpack_public_path__ + "static/flag-se-4f6f571fc7713c7263324af43717f818.svg";